import { useState } from "react";

export interface DateRange {
  from: Date | undefined;
  to: Date | undefined;
}

export const useDateRange = () => {
  const [dateRange, setDateRange] = useState<DateRange>({
    from: undefined,
    to: undefined,
  });

  const updateDateRange = (range: DateRange) => {
    setDateRange(range);
  };

  const resetDateRange = () => {
    setDateRange({
      from: undefined,
      to: undefined,
    });
  };

  return {
    dateRange,
    setDateRange: updateDateRange,
    resetDateRange,
  };
};
